<template>
  <div>
    <h4 class="mb-4 text-center text-uppercase">Elenco ordini</h4>
    <div v-if="loading" class="loading">
      Caricamento in corso...
    </div>
    <div v-if="error" class="error">
      {{ error }}
    </div>

    <div class="content">
      <div v-if="!loading">
        <div class="row">
          <div class="col-6">
            <input type="checkbox" id="checkbox" true-value="1" false-value="0" v-model="filter"
                   v-on:change="filterData()"> <label
              for="checkbox">Non ordinati</label>
          </div>
          <div class="col-6 text-right">
            Anno
            <select name="anno" id="anno" v-model="year" v-on:change="filterData()">
              <option value="0">-</option>
              <option :value="year" v-for="year in years" :key="year">
                {{ year }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <b-table v-if="!loading" id="orders_table" hover flex responsive :items="orders" :fields="fields"
               :tbody-tr-class="getClass"
               striped @row-clicked="expandAdditionalInfo">
        <template v-slot:row-details="row">
          <b-card>
            <b-row class="mb-1" v-if="row.item.idordine">
              <b-col sm="4" class="text-sm-right"><b>ID Progressivo:</b></b-col>
              <b-col>{{ row.item.idordine }}</b-col>
            </b-row>
            <b-row class="mb-1">
              <b-col sm="4" class="text-sm-right"><b>Articolo:</b></b-col>
              <b-col>{{ row.item.articolo }}</b-col>
            </b-row>
            <b-row class="mb-1" v-if="row.item.descrizione.length > 0">
              <b-col sm="4" class="text-sm-right"><b>Descrizione:</b></b-col>
              <b-col>{{ row.item.descrizione }}</b-col>
            </b-row>
            <b-row class="mb-1" v-if="row.item.quantita > 0">
              <b-col sm="4" class="text-sm-right"><b>Quantità:</b></b-col>
              <b-col>{{ row.item.quantita }}</b-col>
            </b-row>
            <b-row class="mb-1" v-if="row.item.mag > 0">
              <b-col sm="4" class="text-sm-right"><b>MAG:</b></b-col>
              <b-col>{{ row.item.mag }}</b-col>
            </b-row>
            <b-row class="mb-1">
              <b-col sm="4" class="text-sm-right"><b>Cliente:</b></b-col>
              <b-col>{{ row.item.cliente }}</b-col>
            </b-row>
            <b-row class="mb-1" v-if="row.item.note.length > 0">
              <b-col sm="4" class="text-sm-right"><b>Note:</b></b-col>
              <b-col>{{ row.item.note }}</b-col>
            </b-row>
            <b-row class="mb-1" v-if="row.item.priorita.length > 0">
              <b-col sm="4" class="text-sm-right"><b>Priorita:</b></b-col>
              <b-col>URGENTE</b-col>
            </b-row>
            <b-row class="mb-1">
              <b-col sm="4" class="text-sm-right"><b>Consegnato:</b></b-col>
              <b-col v-if="row.item.consegnato == 1">SI</b-col>
              <b-col v-if="row.item.consegnato == 0">NO</b-col>
            </b-row>
          </b-card>
        </template>
      </b-table>
    </div>
    <br/>
    <b-button v-if="!loading && !loadingBottom &&  !ended" type="button" v-on:click="onClickMore()"
              class="btn btn-md btn-full-width" v-di variant="secondary">
      Mostra pi&ugrave; risultati
    </b-button>
    <div v-if="loadingBottom && !loading" class="loading">
      Caricamento in corso...
    </div>
    <br/>
    <p>
      <router-link to="/login">Logout</router-link>
    </p>
  </div>
</template>

<script>

export default {
  data() {
    return {
      page: 0,
      ended: false,
      year: new Date().getFullYear(),
      loading: false,
      scrolledToBottom: 0,
      bottomOfWindow: 0,
      loadingBottom: false,
      filter: 0,
      orders: [],
      error: null,
      years: [],
      fields: [
        {key: 'data', label: 'Data'},
        {key: 'articolo', label: 'Articolo'},
        {key: 'qntmag', label: 'Qnt\r\nMAG'},
        {key: 'cliente', label: 'Cliente'},
        {key: 'altro', label: 'n.Ord'}
      ]
    }
  },
  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetchData();
    const year = new Date().getFullYear()
    this.years = Array.from({length: year - 2019}, (value, index) => 2020 + index);
  },
  mounted() {
    this.scroll();
  },
  methods: {
    onClickMore() {
      this.page++;
      this.loadingBottom = true
      this.scrolledToBottom = true // replace it with your code
      this.fetchData();
    },
    /*scroll() {
      window.onscroll = () => {
        this.scrolledToBottom = window.top.scrollY + window.innerHeight + 100
        this.bottomOfWindow = document.documentElement.offsetHeight

        if (this.scrolledToBottom >= this.bottomOfWindow && !this.loadingBottom && !this.ended) {
          this.page++;
          this.loadingBottom = true
          this.scrolledToBottom = true // replace it with your code
          this.fetchData();
        }
      };
    },*/
    filterData() {
      this.orders = [];
      this.page = 0;
      this.ended = false;
      this.fetchData();
    },
    fetchData() {
      this.error = null;
      if (this.page == 0)
        this.loading = true;

      const user = localStorage.getItem('user');
      const requestOptions = {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({user})
      };

      fetch(`https://ordini.saegsrl.com/ajax/action.php?a=getOrders&y=` + this.year + `&p=` + this.page + `&f=` + parseInt(this.filter), requestOptions).then(this.handleResponse);
    },
    getOrders() {
      return this.orders;
    },
    expandAdditionalInfo(row) {
      row._showDetails = !row._showDetails;
    },
    handleResponse(response) {
      return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok || data.error) {
          const error = (data && data.message) || response.statusText;
          return Promise.reject(error);
        }
        if (data.orders.length == 0) {
          this.loadingBottom = false;
          this.ended = true
        } else {
          data.orders.forEach((item) => {
            this.orders.push(item);
          });
        }

        this.loading = false;
        setTimeout(() => {
          this.loadingBottom = false;
        }, 2000);
      });
    },
    getClass(item, type) {
      if (item && type === 'row') {
        return item.class;
      } else {
        return null
      }
    }
  }
};
</script>